import { posterSrc, stillSrc } from '@site/lib/images';
import { BASE_API } from '../api/client';

/**
 * Les visuels, servis par notre propre API.
 *
 * Une Activity ne charge que les domaines déclarés en URL Mapping ; tout le
 * reste est coupé par la politique de sécurité de l'iframe, en silence et sans
 * message — c'est exactement ce qui arrivait aux affiches, qui viennent de
 * `image.tmdb.org`.
 *
 * On aurait pu déclarer un mapping de plus. On passe plutôt par l'API, déjà
 * mappée : une case à cocher en moins au portail, une de moins à oublier, et
 * surtout un seul chemin identique au navigateur comme dans Discord.
 *
 * Le dimensionnement reste celui du site (`@site/lib/images`) : quelle largeur
 * demander à TMDB est une question déjà tranchée.
 */

const TMDB = /^https?:\/\/image\.tmdb\.org\/t\/p\/([^/]+)\/(.+)$/;

/**
 * Réécrit une URL TMDB vers notre relais. Une URL qui n'en est pas une repart
 * telle quelle : le catalogue peut contenir des visuels d'une autre origine.
 */
function parNotreApi(url) {
  if (!url) return null;

  const parties = TMDB.exec(url);
  if (!parties) return url;

  const [, taille, fichier] = parties;
  return `${BASE_API}/tmdb-image/${taille}/${fichier}`;
}

/** Affiche au format 2:3, dimensionnée pour une vignette. */
export const affiche = (url) => parNotreApi(posterSrc(url));

/** Vignette paysage d'un épisode. */
export const vignette = (url) => parNotreApi(stillSrc(url));
